import { ConnectComponent } from '../../_components/ConnectComponent'
import { SignUpPresenter } from './SignUp.presenter'
import { SignUpView } from './SignUp.view'

export const SignUp = ConnectComponent(SignUpView, SignUpPresenter)
